export default __webpack_public_path__ + "static/insfocus_small-4-e15c21eaa9d99fb2b27b4f998946b37a.png";